import React from 'react';
import { useSparkBuilderStore } from 'stores';
import { useUpdateSurveyForm } from 'hooks/common';
import { useFormByID } from 'hooks/Forms';
import InputFormCreator from '../InputValues/InputFormCreator';

type SparkInputValuesContainerProps = {
  onClose: () => void;
};

function SparkInputValuesContainer({
  onClose,
}: SparkInputValuesContainerProps) {
  const inputFormID = useSparkBuilderStore(
    (state) => state.joinedSpark?.attributes.inputFormID
  );
  const { form, isLoading } = useFormByID(inputFormID);
  const { handleFormUpdate } = useUpdateSurveyForm(inputFormID);

  if (isLoading) {
    return <></>;
  }

  return (
    <InputFormCreator
      formConfigJSON={form?.attributes.config}
      onSurveyUpdate={handleFormUpdate}
      onclose={onClose}
    />
  );
}

export default SparkInputValuesContainer;
